import React
    , {useContext} from "react";
import FormSubHeader
    from "./elements/FormSubHeader";
import FormHeader
    from "./elements/FormHeader";
import FormRepeatable
    from "./elements/FormRepeatable";
import FormTextField
    from "./elements/FormTextField";
import {FormData} from "./FormProvider";
import useFormEvents
    from "../../hooks/useFormEvents";
import FormRow
    from "./elements/FormRow";
import FormSelectField
    from "./elements/FormSelectField";
import FormRadioField
    from "./elements/FormRadioField";
import FormCheckboxField
    from "./elements/FormCheckboxField";
import FormValidationHelpers
    from "@helpers/form-validation-helpers";
import ErrorList
    from "./elements/ErrorList";
import {Alert} from "@mui/material";
import styled
    from "styled-components";
import FormLabelField
    from "@components/form-renderer/elements/FormLabelField";

const StyledAlert = styled(Alert)`
    margin-top: 0.5rem;
`

const ElementRenderer = ({
                             template,
                             defaultAnswers,
                             answerIndex = 0,
                             subheaderRow = 0,
                         }) => {
    if (!template.objecttype) {
        throw Error("Unable to render form element: No objecttype provided.");
    }

    const {emitChangesToFields} = useFormEvents();

    let {
        state,
        dispatch,
        findAnswer
    } = useContext(FormData);

    const onChange = (value, action = 'UPDATE_ANSWER') => {
        // Update the field's own value
        dispatch({
            type: action,
            payload: {
                field: template,
                answerIndex,
                value,
            }
        });

        // Update other fields if there are events
        emitChangesToFields(template, value, answerIndex);
    }

    const onBlur = () => {
        const validationResult = FormValidationHelpers.validateField(values, template);
        if (validationResult !== true) {
            dispatch({
                type: "SET_ERROR",
                payload: {
                    field: template,
                    answerIndex,
                    value: validationResult
                }
            })
        } else {
            dispatch({
                type: "CLEAR_ERROR",
                payload: {
                    field: template,
                    answerIndex,
                }
            })
        }
    }

    const values = findAnswer(template.id, answerIndex);

    const props = {
        template,
        values: {...values},
        disabled: state.isWebform && template?.content?.lockedWebform ? template?.content?.lockedWebform === 1 : false,
        defaultAnswers,
        onChange,
        onBlur
    };

    if (props.values.errors) {
        props.error = true;
    }

    // console.log(props);

    /**
     formHeader: Header
     formSubheader: Sub Header
     formRepeatable: Repeatable
     formRow: Table
     formLabel: Label
     formCRM: CRM Client
     formCRMLocation: CRM Location
     formMultiple: CRM Zone
     formPageSplit: Page Break
     formLineSpace: Line Space
     formLineSpace: Draw Line
     formText: Text Box
     formText: Number
     formText: Currency
     formText: Date
     formText: Time
     formText: Location
     formText: Email
     formText: Telephone
     formMultiple: Checkbox
     formMultiple: Radio Button
     formMultiple: Dropdown
     formMultiple: Buttons
     formPhoto: Camera
     formInlineImage: Image
     formAttachment: Attachments
     formSignature: Signature
     formCalculate: Calculation
     formCanvas: Signature
     formPayment: Card Payment
     formSlider: Slider
     formGPS: GPS
     formBarcode: Barcode
     */

    const element = () => {
        switch (template.objecttype) {
            case "formHeader":
                return <FormHeader {...props}/>;
            case "formSubheader":
                return <FormSubHeader {...props}/>;
            case "formRepeatable":
                return <FormRepeatable subheaderRow={subheaderRow} {...props}/>;
            case "formText":
                return <FormTextField {...props}/>;
            case "formMultiple":
                switch (template?.content?.choiceType) {
                    case 'dropdown':
                        return <FormSelectField {...props} />;
                    case 'radio':
                        return <FormRadioField {...props} />;
                    // case 'button':
                    //     return <FormMultipleField {...props} />;
                    default:
                        return <FormCheckboxField {...props} />;
                }
            case "formRow":
                return <FormRow subheaderRow={subheaderRow} {...props}/>;
            case "formLabel":
                return <FormLabelField {...props}/>;
            case "formCRM":
                return <div>formCRM</div>;
            case "formCRMLocation":
                return <div>formCRMLocation</div>;
            case "formPageSplit":
                return <div>formPageSplit</div>;
            case "formLineSpace":
                return <div>formLineSpace</div>;
            case "formPhoto":
                return <div>formPhoto</div>;
            case "formInlineImage":
                return <div>formInlineImage</div>;
            case "formAttachment":
                return <div>formAttachment</div>;
            case "formSignature":
                return <div>formSignature</div>;
            case "formCalculate":
                return <div>formCalculate</div>;
            case "formCanvas":
                return <div>formCanvas</div>;
            case "formPayment":
                return <div>formPayment</div>;
            case "formSlider":
                return <div>formSlider</div>;
            case "formGPS":
                return <div>formGPS</div>;
            case "formBarcode":
                return <div>formBarcode</div>;
            default:
                return;
        }
    }

    // let visible = content.visible;
    //
    // if (props.values.visible !== content.visible) {
    //     visible = props.values.visible;
    // }

    // console.log(props.values);

    return (
        <div style={{
            display: props.values.visible === true ? 'block' : 'none'
        }} className='fz-form-element-container mb-6'>
            {element()}

            {props.values.errors && (
                <StyledAlert className='fz-form-field-error-container' severity="error">
                    <ErrorList errors={props.values.errors} />
                </StyledAlert>
            )}
        </div>
    )
}

export default ElementRenderer;